import {
  ArchiveIcon,
  DeleteIcon,
  EditIcon,
  ResourceMenuActions,
  RestoreIcon,
} from '@all-manager/design-system-v2';
import type { TopicDatabase } from '../../../../types';
import CreateUpdateTopicModal from '../CreateUpdateTopicModal/CreateUpdateTopicModal';
import DeleteTopicModal from '../DeleteTopicModal/DeleteTopicModal';
import TopicArchiveModal from '../TopicArchiveModal/TopicArchiveModal';
import { useTopicMenuAction } from './useTopicMenuAction';

type Props = {
  topic: TopicDatabase;
  onDeleted?: (topicId: string) => void;
};

export default function TopicMenuAction(props: Props) {
  const hook = useTopicMenuAction();

  return (
    <>
      <ResourceMenuActions
        size="small"
        tooltip={`Options du sujet ${props.topic.name}`}
        actions={[
          {
            id: 'edit',
            label: 'Modifier',
            icon: <EditIcon fontSize="small" />,
            onClick: hook.handleOpenEditModal,
          },
          {
            id: 'archive',
            label: props.topic.archived ? 'Désarchiver' : 'Archiver',
            icon: props.topic.archived ? <RestoreIcon fontSize="small" /> : <ArchiveIcon fontSize="small" />,
            onClick: hook.handleOpenArchiveModal,
          },
          { type: 'divider', id: 'divider' },
          {
            id: 'delete',
            label: 'Supprimer',
            icon: <DeleteIcon fontSize="small" color="error" />,
            onClick: hook.handleOpenDeleteModal,
          },
        ]}
      />

      {hook.activeModal === 'edit' ? (
        <CreateUpdateTopicModal topic={props.topic} onClose={hook.handleCloseModal} />
      ) : null}

      {hook.activeModal === 'archive' ? (
        <TopicArchiveModal topic={props.topic} onClose={hook.handleCloseModal} />
      ) : null}

      {hook.activeModal === 'delete' ? (
        <DeleteTopicModal topic={props.topic} onClose={hook.handleCloseModal} onDeleted={props.onDeleted} />
      ) : null}
    </>
  );
}
